<i18n>
{
  "ja": {
    "contact": {
      "name": "名前",
      "email": "メールアドレス",
      "title": "メッセージ件名",
      "content": "メッセージ内容",
      "send": "送信",
      "placeholders": {
        "name": "名前を入力",
        "email": "メールアドレスを入力",
        "title": "メッセージの件名を入力",
        "content": "メッセージ内容の入力"
      }
    }
  },
  "en": {
    "contact": {
      "name": "Name",
      "email": "Email Address",
      "title": "Message Subject",
      "content": "Message Content",
      "send": "Send Message",
      "placeholders": {
        "name": "Enter Your Name",
        "email": "Enter Your Email Address",
        "title": "Enter Message Subject",
        "content": "Enter Message Content"
      }
    }
  }
}
</i18n>
<template>
  <form>
    <v-row>
      <v-col :cols="pcOnly ? 6 : 12">
        <v-text-field hide-details outlined :label="$t('contact.name')" v-model="name"
                      :placeholder="$t('contact.placeholders.name')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="pcOnly ? 8 : 12">
        <v-text-field hide-details outlined :label="$t('contact.email')" v-model="title"
                      :placeholder="$t('contact.placeholders.email')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field hide-details outlined :label="$t('contact.title')" v-model="title"
                      :placeholder="$t('contact.placeholders.title')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea rows="4" hide-details no-resize auto-grow outlined :label="$t('contact.content')" v-model="content"
                    :placeholder="$t('contact.placeholders.content')"/>
      </v-col>
    </v-row>
    <div class="contact-actions d-flex mt-4">
      <v-btn :disabled="disable" block x-large tile color="primary" @click="submit">
        <span>{{ $t('contact.send') }}</span>
        <v-icon class="ms-3">mdi-arrow-{{ isRtl ? 'left' : 'right' }}</v-icon>
      </v-btn>
    </div>
  </form>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'

export default {
  computed: {
    ...GlobalComputed,
  },
  data() {
    return {
      title: '',
      name: '',
      email: '',
      content: '',
      disable: true,
    }
  },
  watch: {
    name: function () {
      this.checkSubmit()
    },
    email: function () {
      this.checkSubmit()
    },
    title: function () {
      this.checkSubmit()
    },
    content: function () {
      this.checkSubmit()
    },
  },
  methods: {
    checkSubmit() {
      this.disable = this.name.trim() == "" || this.title.trim() == "" || this.email.trim() == "" || this.content.trim() == "";
    },
    submit(){
      var subject = this.title;
      var body = this.content;
      //改行コードの変換対応
      body = body.replace(/\n\r?/g, '%0D%0A');
      location.href = 'mailto:info@i-wa.jp' + '?subject=' + subject + '&body=' + "【"+this.name+"】" +"%0D%0A%0D%0A"+body;
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
